import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowPointDownHeavy = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M32 15L20 27L8 15",
		stroke: "currentColor",
		strokeWidth: 3.3333,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgArrowPointDownHeavy);
export default ForwardRef;
